<template>
  <div class="app-container">
    <AppHeader v-if="!isLoginPage" />
    <router-view />
    <AppFooter v-if="!isLoginPage" />
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter
  },
  setup() {
    const route = useRoute()
    
    const isLoginPage = computed(() => {
      return route.name === 'Login'
    })

    return {
      isLoginPage
    }
  }
}
</script>

<style>
@import 'normalize.css';

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
}

.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
</style>
